import { useEffect, useState } from 'react';

const useDocumentTitle = title => {
    const [documentTitle, setDocumentTitle] = useState(document.title);

    const updateDocumentTitle = updateTitle => {
        document.title = updateTitle;
        setDocumentTitle(updateTitle);
    };

    useEffect(() => {
        const prevTitle = document.title;

        if (typeof title === 'string' && !title.includes('undefined')) {
            updateDocumentTitle(title);
        } else {
            updateDocumentTitle(prevTitle);
        }

        return () => {
            updateDocumentTitle(title);
        };
    }, [setDocumentTitle, title]);

    return { documentTitle };
};

export default useDocumentTitle;
